'use strict';

/**
 * Tingle Context
 * The environment for tingle's initialization
 * @author gnosaij
 *
 * Copyright 2014-2015, Tingle Team, Alinw.
 * All rights reserved.
 */

var win = window;
var doc = document;

var ua = navigator.userAgent;
var isMobile = !!ua.match(/mobile/i) || 'orientation' in win;
var isPC = !isMobile;

var supportTouch = 'ontouchstart' in window;
var support3D = 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix();
var supportHairline = function () {
    var support = false;
    if (win.devicePixelRatio && devicePixelRatio >= 2) {
        var testElem = doc.createElement('div');
        testElem.style.border = '.5px solid transparent';
        doc.body.appendChild(testElem);
        if (testElem.offsetHeight == 1) {
            // 0.5 + 0.5 = 1
            support = true;
        }
        doc.body.removeChild(testElem);
    }
    return support;
}();

// 常量
var TOUCH_START = supportTouch ? 'touchstart' : 'mousedown';
var TOUCH_MOVE = supportTouch ? 'touchmove' : 'mousemove';
var TOUCH_END = supportTouch ? 'touchend' : 'mouseup';
var TOUCH_CANCEL = supportTouch ? 'touchcancel' : 'mouseup';

var env = {
    // 是什么环境
    isPC: isPC,
    isMobile: isMobile,

    // 是否支持
    support3D: support3D,
    supportHairline: supportHairline,
    supportTouch: supportTouch,

    // 事件去差异
    TOUCH_START: TOUCH_START,
    TOUCH_MOVE: TOUCH_MOVE,
    TOUCH_END: TOUCH_END,
    TOUCH_CANCEL: TOUCH_CANCEL,
    RESIZE: 'resize'
};

module.exports = env;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImVudi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQVNBLElBQU0sTUFBTSxNQUFaO0FBQ0EsSUFBTSxNQUFNLFFBQVo7O0FBRUEsSUFBTSxLQUFLLFVBQVUsU0FBckI7QUFDQSxJQUFNLFdBQVcsQ0FBQyxDQUFDLEdBQUcsS0FBSCxDQUFTLFNBQVQsQ0FBRixJQUF5QixpQkFBaUIsR0FBM0Q7QUFDQSxJQUFNLE9BQU8sQ0FBQyxRQUFkOztBQUVBLElBQU0sZUFBZSxrQkFBa0IsTUFBdkM7QUFDQSxJQUFNLFlBQWEscUJBQXFCLE1BQXJCLElBQStCLFNBQVMsSUFBSSxlQUFKLEVBQTNEO0FBQ0EsSUFBTSxrQkFBbUIsWUFBTTtBQUMzQixRQUFJLFVBQVUsS0FBZDtBQUNBLFFBQUksSUFBSSxnQkFBSixJQUF3QixvQkFBb0IsQ0FBaEQsRUFBbUQ7QUFDL0MsWUFBTSxXQUFXLElBQUksYUFBSixDQUFrQixLQUFsQixDQUFqQjtBQUNBLGlCQUFTLEtBQVQsQ0FBZSxNQUFmLEdBQXdCLHdCQUF4QjtBQUNBLFlBQUksSUFBSixDQUFTLFdBQVQsQ0FBcUIsUUFBckI7QUFDQSxZQUFJLFNBQVMsWUFBVCxJQUF5QixDQUE3QixFQUFnQzs7QUFDNUIsc0JBQVUsSUFBVjtBQUNIO0FBQ0QsWUFBSSxJQUFKLENBQVMsV0FBVCxDQUFxQixRQUFyQjtBQUNIO0FBQ0QsV0FBTyxPQUFQO0FBQ0gsQ0FadUIsRUFBeEI7OztBQWVBLElBQU0sY0FBYyxlQUFlLFlBQWYsR0FBOEIsV0FBbEQ7QUFDQSxJQUFNLGFBQWEsZUFBZSxXQUFmLEdBQTZCLFdBQWhEO0FBQ0EsSUFBTSxZQUFZLGVBQWUsVUFBZixHQUE0QixTQUE5QztBQUNBLElBQU0sZUFBZSxlQUFlLGFBQWYsR0FBK0IsU0FBcEQ7O0FBRUEsSUFBTSxNQUFNOztBQUVSLGNBRlE7QUFHUixzQkFIUTs7O0FBTVIsd0JBTlE7QUFPUixvQ0FQUTtBQVFSLDhCQVJROzs7QUFXUiw0QkFYUTtBQVlSLDBCQVpRO0FBYVIsd0JBYlE7QUFjUiw4QkFkUTtBQWVSLFlBQVE7QUFmQSxDQUFaOztBQWtCQSxPQUFPLE9BQVAsR0FBaUIsR0FBakIiLCJmaWxlIjoiZW52LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBUaW5nbGUgQ29udGV4dFxuICogVGhlIGVudmlyb25tZW50IGZvciB0aW5nbGUncyBpbml0aWFsaXphdGlvblxuICogQGF1dGhvciBnbm9zYWlqXG4gKlxuICogQ29weXJpZ2h0IDIwMTQtMjAxNSwgVGluZ2xlIFRlYW0sIEFsaW53LlxuICogQWxsIHJpZ2h0cyByZXNlcnZlZC5cbiAqL1xuXG5jb25zdCB3aW4gPSB3aW5kb3c7XG5jb25zdCBkb2MgPSBkb2N1bWVudDtcblxuY29uc3QgdWEgPSBuYXZpZ2F0b3IudXNlckFnZW50O1xuY29uc3QgaXNNb2JpbGUgPSAhIXVhLm1hdGNoKC9tb2JpbGUvaSkgfHwgJ29yaWVudGF0aW9uJyBpbiB3aW47XG5jb25zdCBpc1BDID0gIWlzTW9iaWxlO1xuXG5jb25zdCBzdXBwb3J0VG91Y2ggPSAnb250b3VjaHN0YXJ0JyBpbiB3aW5kb3c7XG5jb25zdCBzdXBwb3J0M0QgPSAoJ1dlYktpdENTU01hdHJpeCcgaW4gd2luZG93ICYmICdtMTEnIGluIG5ldyBXZWJLaXRDU1NNYXRyaXgoKSk7XG5jb25zdCBzdXBwb3J0SGFpcmxpbmUgPSAoKCkgPT4ge1xuICAgIHZhciBzdXBwb3J0ID0gZmFsc2U7XG4gICAgaWYgKHdpbi5kZXZpY2VQaXhlbFJhdGlvICYmIGRldmljZVBpeGVsUmF0aW8gPj0gMikge1xuICAgICAgICBjb25zdCB0ZXN0RWxlbSA9IGRvYy5jcmVhdGVFbGVtZW50KCdkaXYnKTtcbiAgICAgICAgdGVzdEVsZW0uc3R5bGUuYm9yZGVyID0gJy41cHggc29saWQgdHJhbnNwYXJlbnQnO1xuICAgICAgICBkb2MuYm9keS5hcHBlbmRDaGlsZCh0ZXN0RWxlbSk7XG4gICAgICAgIGlmICh0ZXN0RWxlbS5vZmZzZXRIZWlnaHQgPT0gMSkgeyAvLyAwLjUgKyAwLjUgPSAxXG4gICAgICAgICAgICBzdXBwb3J0ID0gdHJ1ZTtcbiAgICAgICAgfVxuICAgICAgICBkb2MuYm9keS5yZW1vdmVDaGlsZCh0ZXN0RWxlbSk7XG4gICAgfVxuICAgIHJldHVybiBzdXBwb3J0O1xufSkoKTtcblxuLy8g5bi46YePXG5jb25zdCBUT1VDSF9TVEFSVCA9IHN1cHBvcnRUb3VjaCA/ICd0b3VjaHN0YXJ0JyA6ICdtb3VzZWRvd24nO1xuY29uc3QgVE9VQ0hfTU9WRSA9IHN1cHBvcnRUb3VjaCA/ICd0b3VjaG1vdmUnIDogJ21vdXNlbW92ZSc7XG5jb25zdCBUT1VDSF9FTkQgPSBzdXBwb3J0VG91Y2ggPyAndG91Y2hlbmQnIDogJ21vdXNldXAnO1xuY29uc3QgVE9VQ0hfQ0FOQ0VMID0gc3VwcG9ydFRvdWNoID8gJ3RvdWNoY2FuY2VsJyA6ICdtb3VzZXVwJztcblxuY29uc3QgZW52ID0ge1xuICAgIC8vIOaYr+S7gOS5iOeOr+Wig1xuICAgIGlzUEMsXG4gICAgaXNNb2JpbGUsXG5cbiAgICAvLyDmmK/lkKbmlK/mjIFcbiAgICBzdXBwb3J0M0QsXG4gICAgc3VwcG9ydEhhaXJsaW5lLFxuICAgIHN1cHBvcnRUb3VjaCxcblxuICAgIC8vIOS6i+S7tuWOu+W3ruW8glxuICAgIFRPVUNIX1NUQVJULFxuICAgIFRPVUNIX01PVkUsXG4gICAgVE9VQ0hfRU5ELFxuICAgIFRPVUNIX0NBTkNFTCxcbiAgICBSRVNJWkU6ICdyZXNpemUnXG59O1xuXG5tb2R1bGUuZXhwb3J0cyA9IGVudjsiXSwic291cmNlUm9vdCI6Ii9zb3VyY2UvIn0=



/*****************
 ** WEBPACK FOOTER
 ** ./~/@ali/tingle-context/dist/env.js
 ** module id = 3
 ** module chunks = 0
 **/